import React from 'react';
import withSnackbar from '@common/Snackbar/withSnackbar';
import withDrawer from '@common/Drawer/v2/withDrawer';
import { withRouter } from 'react-router';
import Flags from '@utils/Flags';
// widgets
import Dialog from 'common/Dialog';
import ErrorBoundary from '@common/ErrorBoundary';
import { withFacade } from '@commonFacades/withfacades';
import fdpHelper from '@utils/FDPhelper';
import fdpHelperV2 from '@utils/FDPHelperV2';
import WidgetizedPageFacade from 'fk-cp-common-components/commonFacade/WidgetizedPageFacade';
import { Reseller } from 'fk-cp-common-components/commonFacade/ResellerFacade';
import StaticStoreManager from 'fk-cp-common-components/utils/StaticStoreManager';
import { TimelineFacade as TimelineFacadeUtils } from 'fk-cp-common-components/commonFacade/TimelineFacade';
import { PriceWidgetFacade } from 'fk-cp-common-components/commonFacade/PriceWidgetFacade';
import { InstallationWidgetFacade } from 'fk-cp-common-components/commonFacade/InstallationWidget';
import UserLoginStatus from '@utils/UserLoginStatus';
import ApiCallerInterface from '@utils/ApiCallerInterface';
import Drawer from '@common/Drawer';
import { triggerFAppAction, redirectToChat, redirectToHomePage } from '@utils/fAppRedirectionUtil';
import Header from '@common/Header';
import withDialog from '@common/Dialog/withDialog';
import withToolTip from 'fk-cp-common-components/webComponents/V4/common//ToolTip/withToolTip';
import PageLevelLoader from 'fk-cp-common-components/webComponents/V4/smartComponents/PageLevelLoader';
import { formatMessageByString } from '@utils/i18n';
import DownloadPolicy from 'fk-cp-common-components/commonFacade/DownloadPolicy';
import { ShareOrderFacade } from 'fk-cp-common-components/commonFacade/ShareOrderFacade';
import OpenBoxDelivery from 'fk-cp-common-components/commonFacade/OpenBoxDelivery';
import TrackIncident from 'fk-cp-common-components/commonFacade/TrackIncidentFacade';
import { RecoFacade } from 'fk-cp-common-components/commonFacade/RecoFacade';
import { ApiCallerV4InlineAction } from '@utils/ApiCallerInterface';
import { redirectToClpUrl } from '@utils/fAppRedirectionUtil';
import ErrorCard from '@common/ErrorCard/v2';
import ApiCaller from 'fk-cp-shared/utils/MapiApiHelper';
import MapiBaseAjaxConfig from '../../MapiBaseAjaxConfig';
import { ChangeAddress } from 'fk-cp-common-components/commonFacade/ChangeAddressFacade';
import TwoFactorAuth from '@common/TwoFactorAuth';
import PushNotificationHelper from 'rv-push-notification/PushNotificationHelper';
import RegistrationHelper from 'rv-push-notification/RegistrationHelper';
import store from '../../clientStore';
import { _logger } from '@utils/ApiStoreInterface';
import trackerStore from '@tracker/store';
var RoutesWrapper = function (props) {
    var WidgetizedPageFacade = props.WidgetizedPageFacade, InstallationWidgetFacade = props.InstallationWidgetFacade, Reseller = props.Reseller, RecoFacade = props.RecoFacade, TimelineFacade = props.TimelineFacade, PriceWidgetFacade = props.PriceWidgetFacade, closeDrawer = props.closeDrawer, openDrawer = props.openDrawer, openDialog = props.openDialog, closeDialog = props.closeDialog, showSnackbar = props.showSnackbar, hideSnackbar = props.hideSnackbar, showToolTip = props.showToolTip, hideToolTip = props.hideToolTip, router = props.router, DownloadPolicy = props.DownloadPolicy, ShareOrderFacade = props.ShareOrderFacade, OpenBoxDelivery = props.OpenBoxDelivery, TrackIncident = props.TrackIncident, ChangeAddress = props.ChangeAddress;
    StaticStoreManager.setStoreAttrs({
        WidgetizedPageFacade: WidgetizedPageFacade,
        Reseller: Reseller,
        RecoFacade: RecoFacade,
        TimelineFacade: TimelineFacade,
        PriceWidgetFacade: PriceWidgetFacade,
        InstallationWidgetFacade: InstallationWidgetFacade,
        ApiCallerInterface: ApiCallerInterface,
        fdpHelper: fdpHelper,
        fdpHelperV2: fdpHelperV2,
        Dialog: Dialog,
        Flags: Flags,
        UserLoginStatus: UserLoginStatus,
        ErrorBoundary: ErrorBoundary,
        Drawer: Drawer,
        redirectToChat: redirectToChat,
        OrderDetailsLoader: PageLevelLoader,
        router: router,
        Header: Header,
        showSnackbar: showSnackbar,
        hideSnackbar: hideSnackbar,
        showToolTip: showToolTip,
        hideToolTip: hideToolTip,
        closeDrawer: closeDrawer,
        openDrawer: openDrawer,
        openDialog: openDialog,
        closeDialog: closeDialog,
        formatMessageByString: formatMessageByString,
        DownloadPolicy: DownloadPolicy,
        ShareOrderFacade: ShareOrderFacade,
        OpenBoxDelivery: OpenBoxDelivery,
        TrackIncident: TrackIncident,
        ApiCallerV4InlineAction: ApiCallerV4InlineAction,
        redirectToClpUrl: redirectToClpUrl,
        triggerFAppAction: triggerFAppAction,
        ErrorCard: ErrorCard,
        redirectToHomePage: redirectToHomePage,
        MapiBaseAjaxConfig: MapiBaseAjaxConfig,
        ApiCaller: ApiCaller,
        ChangeAddress: ChangeAddress,
        TwoFactorAuth: TwoFactorAuth,
        PushNotificationHelper: PushNotificationHelper,
        RegistrationHelper: RegistrationHelper,
        store: store,
        _logger: _logger,
        endAllViews: trackerStore.endAllViews,
        flushEventQueue: trackerStore.flushEventQueue
    });
    return <React.Fragment>{props.children}</React.Fragment>;
};
var mapFacadeToProps = {
    WidgetizedPageFacade: WidgetizedPageFacade,
    Reseller: Reseller,
    RecoFacade: RecoFacade,
    TimelineFacade: TimelineFacadeUtils,
    PriceWidgetFacade: PriceWidgetFacade,
    InstallationWidgetFacade: InstallationWidgetFacade,
    DownloadPolicy: DownloadPolicy,
    ShareOrderFacade: ShareOrderFacade,
    OpenBoxDelivery: OpenBoxDelivery,
    TrackIncident: TrackIncident,
    ChangeAddress: ChangeAddress
};
export default withRouter(withDrawer(withSnackbar(withDialog(withToolTip(withFacade(mapFacadeToProps)((RoutesWrapper)))))));
